import Guarded from '@/components/Guarded';

import { usePageContext } from 'vike-react/usePageContext';
import DMPageWrapper from './components/DMPageWrapper';

export default function Page() {
  const chatId = usePageContext().routeParams?.chatId;

  return (
    <Guarded>
      <DMPageWrapper chatId={chatId === 'me' ? chatId : parseInt(chatId, 10) || 0} />
    </Guarded>
  );
}
